import { render, staticRenderFns } from "./protocolDisplay.vue?vue&type=template&id=010343fb&scoped=true&"
import script from "./protocolDisplay.vue?vue&type=script&lang=js&"
export * from "./protocolDisplay.vue?vue&type=script&lang=js&"
import style0 from "./protocolDisplay.vue?vue&type=style&index=0&id=010343fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010343fb",
  null
  
)

export default component.exports